<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">

            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Allotment List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="fetchAy" 
                        :items="ay_list" item-text="name" item-value="id" label="Academic Year" outlined
                        persistent-hint hint="Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="fetchStandard" 
                        :items="filter_standard_list" item-text="standard" item-value="id" @change="getAdmissionRounds(fetchStandard)" label="Standard" outlined
                        persistent-hint hint="Select Standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="fetchRound" 
                        :items="filter_admission_round_list" item-text="name" item-value="id" label="Round" outlined
                        persistent-hint hint="Select Round" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="fetchStream" 
                        :items="filter_stream_list" item-text="name" item-value="id" label="Stream" outlined
                        persistent-hint hint="Select Stream" />
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display">
                <v-btn class="mb-2 button" @click="getAllotmentList()" :loading="dataLoader">Fetch Allotment List</v-btn>
            </v-row>
        </v-card>
        <v-card class="box">
            <v-data-table v-model="selectedRows" show-select :headers="headers" :loading="dataLoader" :items="allotment_list" class="elevation-1 mytable"
                dense :search="search">

                <template v-slot:top>
                    <v-row dense align="center" class="mt-2 ml-2" v-if="allotment_list.length>0">
                        <v-col cols="12" class="d-flex align-center flex-wrap">
                            <v-btn color="primary" class="mr-2 mb-2"
                                :disabled="selectedRows.length == 0"  @click="sendNotification('EMAIL')" small>
                                <v-icon left>mdi-email</v-icon>
                                Send Email
                            </v-btn>

                            <v-btn color="success" class="mr-2 mb-2"
                                :disabled="selectedRows.length == 0"  @click="sendNotification('WHATSAPP')" small>
                                <v-icon left>mdi-whatsapp</v-icon>
                                Send WhatsApp
                            </v-btn>

                            <v-btn color="info" class="mr-2 mb-2" disabled
                                 @click="sendNotification('SMS')" small>
                                <v-icon left>mdi-message</v-icon>
                                Send SMS
                            </v-btn>

                        </v-col>
                    </v-row>

                    <v-row dense align="center">
                        <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                                <v-icon left color="success">
                                    mdi-export
                                </v-icon>

                                Export
                            </v-btn>
                        </v-col>

                        <v-col cols="12" sm="5" md="5" class="mr-8">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details />
                        </v-col>

                       
                        <v-col cols="12" sm="3" md="3" class="d-flex align-center">
                            <v-btn rounded color="success" small tile class="mr-2" @click="openFileSelector()">
                                <v-icon class="mr-2" small>
                                    mdi-file-import
                                </v-icon>

                                Import Allotment List
                            </v-btn>

                            <v-dialog v-model="dialog" max-width="800px">
                                <template v-slot:activator="{ on }">
                                    <v-btn class="mb-2 button" small v-on="on">
                                        Add Allotment
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-form v-model="valid">
                                        <v-card-title class="toolbar">
                                            <span class="headline">
                                                {{ formTitle }}
                                            </span>
                                        </v-card-title>

                                        <v-card-text class="pb-2 mt-2">
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Candidate Name" v-model="name" outlined
                                                        dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Mobile Number" v-model="mobile_no"
                                                        outlined dense maxlength="10" counter="10" type="tel"
                                                        @input="mobile_no = mobile_no.replace(/[^0-9]/g, '').slice(0, 10)" />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Email" v-model="email" outlined dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Application Form Number"
                                                        v-model="application_id" outlined dense/>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Merit Number" v-model="merit_no" outlined
                                                        dense type="number" />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-text-field label="Enter Merit Marks" v-model="merit_marks"
                                                        outlined dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Standard" v-model="standard" outlined
                                                        :items="standard_list" item-text="standard" item-value="id"
                                                        dense @change="getAdmissionRounds(standard)" />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Admission Round" v-model="round"
                                                        outlined :items="admission_round_list" item-text="name"
                                                        item-value="id" dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Academic year" v-model="ay" outlined
                                                        :items="ay_list" item-text="name" item-value="id" dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Stream" v-model="stream" outlined
                                                        :items="stream_list" item-text="name" item-value="id" dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Gender" v-model="gender" outlined
                                                        :items="gender_list" item-text="name" item-value="id" dense />
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-icon color="error" small>*</v-icon>
                                                    <v-autocomplete label="Select Category" v-model="category" outlined
                                                        :items="category_list" item-text="name" item-value="id" dense />
                                                </v-col>

                                            </v-row>
                                        </v-card-text>

                                        <v-card-actions class="justify-center pt-0">
                                            <v-btn class="button" @click="close()" :disabled="!valid">
                                                Cancel
                                            </v-btn>
                                            <v-btn color="primary button" @click="save" :disabled="!valid">
                                                {{ editedIndex === -1 ? 'Save' : 'Update' }}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-form>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">
                                edit
                            </v-icon>
                        </v-avatar>

                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </v-avatar>
                    </div>
                </template>
                <!-- <template v-slot:header.select>
                    <div class="d-flex align-center justify-center">
                         <span class="ml-1">Select All</span>
                        <v-checkbox v-model="selectAll" @change="toggleSelectAll" hide-details dense
                            class="ma-0 pa-0" />
                    </div>
                </template>

                <template v-slot:item.select="{ item }">
                    <div class="d-flex justify-center align-center">
                        <v-checkbox v-model="selectedRows" :value="item" hide-details dense class="ma-0 pa-0" />
                    </div>
                </template> -->
                <template v-slot:item.is_email_verified="{ item }">
                    <div class="text-center">
                        <v-icon :color="item.is_email_verified ? 'success' : 'error'">
                            {{ item.is_email_verified ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                    </div>
                </template>

                <template v-slot:item.is_mobile_verified="{ item }">
                    <div class="text-center">
                        <v-icon :color="item.is_mobile_verified ? 'success' : 'error'">
                            {{ item.is_mobile_verified ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                    </div>
                </template>

            </v-data-table>

             <v-dialog v-model="import_dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                    <span class="headline mb-5">Import Allotment List</span>
                    <v-spacer></v-spacer>
                    <v-btn small color="success" @click="generateExcel" class="mb-5">
                    Download Excel Template
                    </v-btn>
                    </v-card-title>

                    <v-card-text>
                    <v-file-input
                        v-model="file"
                        label="Select CSV File"
                        prepend-icon="mdi-file"
                        outlined
                        rounded
                        dense
                        show-size
                    ></v-file-input>
                    </v-card-text>

                    <v-card-actions class="justify-center">
                    <v-btn color="blue darken-1" text @click="import_dialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" @click="importAllotmentList" :disabled="!file" :loading="importLoader">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="result_dialog" max-width="950px">
                <v-card>
                    <v-card-title class="toolbar white--text">
                        Import Summary Logs
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="result_dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text class="mt-4">
                        <v-tabs v-model="active_tab" background-color="transparent" color="primary" grow>
                            <v-tab>
                                <v-icon left color="success">mdi-check-circle</v-icon>
                                Success Records ({{ success_allotment_list.length }})
                            </v-tab>
                            <v-tab>
                                <v-icon left color="error">mdi-alert-circle</v-icon>
                                Failed Records ({{ failed_allotment_list.length }})
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="active_tab" class="mt-4">
                            <v-tab-item>
                                <v-data-table :headers="success_headers" :items="success_allotment_list" dense class="elevation-1">
                                    <template v-slot:item.status="{ item }">
                                        <v-chip small color="success" dark class="font-weight-bold">
                                            {{ item.status || 'Saved' }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                            </v-tab-item>

                            <v-tab-item>
                                <v-data-table :headers="failed_headers" :items="failed_allotment_list" dense class="elevation-1">
                                    <template v-slot:item.reason="{ item }">
                                        <span class="red--text font-weight-bold">{{ item.reason }}</span>
                                    </template>
                                </v-data-table>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import { email } from "vuelidate/lib/validators";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        name: "",
        mobile_no: "",
        email: "",
        application_id: "",
        merit_no: "",
        merit_marks: "",
        round: "",
        stream: "",
        category: "",
        gender: "",
        ay: "",
        standard: "",
        is_email_verified: "",
        is_mobile_verified: "",
        dialog: false,
        selectedRows: [],
        selectAll: false,
        headers: [
            // {
            //     text: "Select",
            //     align: "center",
            //     sortable: false,
            //     value: "select",
            //     width: "100px"
            // },
            {
                text: "Sr No",
                align: "center",
                sortable: false,
                value: "srno",
                width: "80px"
            },
             {
                text: "Application Id",
                align: "center",
                sortable: false,
                value: "application_id",
                width: "140px"
            },
            {
                text: "Candidate Name",
                align: "left",
                sortable: false,
                value: "name",
                width: "220px"
            },
            {
                text: "Mobile No.",
                align: "left",
                sortable: false,
                value: "mobile_no",
                width: "140px"
            },
            {
                text: "Email",
                align: "left",
                sortable: false,
                value: "email",
                width: "250px"
            },
            {
                text: "Gender",
                align: "center",
                sortable: false,
                value: "gender",
                width: "120px"
            },
            {
                text: "Category",
                align: "left",
                sortable: false,
                value: "category",
                width: "140px"
            },
            {
                text: "Merit No",
                align: "center",
                sortable: false,
                value: "merit_no",
                width: "120px"
            },
            {
                text: "Merit Marks",
                align: "center",
                sortable: false,
                value: "merit_marks",
                width: "140px"
            },
            {
                text: "Academic year",
                align: "center",
                sortable: false,
                value: "ay",
                width: "140px"
            },
            {
                text: "Round",
                align: "center",
                sortable: false,
                value: "round",
                width: "120px"
            },
            {
                text: "Standard",
                align: "center",
                sortable: false,
                value: "standard",
                width: "120px"
            },
            {
                text: "Stream",
                align: "left",
                sortable: false,
                value: "stream",
                width: "140px"
            },
            {
                text: "Is Email Sent?",
                align: "center",
                sortable: false,
                value: "is_email_verified",
                width: "170px"
            },
            // {
            //     text: "Is SMS Sent?",
            //     align: "center",
            //     sortable: false,
            //     value: "is_sms_verified",
            //     width: "170px"
            // },
            {
                text: "Is WhatsApp sent?",
                align: "center",
                sortable: false,
                value: "is_mobile_verified",
                width: "170px"
            },
            {
                text: "Actions",
                value: "action",
                sortable: false,
                align: "center",
                width: "120px"
            },
        ],
        allotment_list: [],
        standard_list: [],
        gender_list: [],
        category_list: [],
        stream_list: [],
        ay_list: [],
        admission_round_list: [],
        editedIndex: -1,
        file:null,
        import_dialog:false,
        editedItem: {
            id: "",
            name: "",
            mobile_no: "",
            email: "",
            application_id: "",
            merit_no: "",
            merit_marks: "",
            round: "",
            stream: "",
            standard: "",
            gender: "",
            category: "",
            ay: "",
            is_email_verified: "",
            is_mobile_verified: ""
        },
        defaultItem: {
            id: "",
            name: "",
            mobile_no: "",
            email: "",
            application_id: "",
            merit_no: "",
            merit_marks: "",
            round: "",
            stream: "",
            standard: "",
            gender: "",
            category: "",
            ay: "",
            is_email_verified: "",
            is_mobile_verified: ""
        },
        dataLoader: false,
        fetchAy: "",
        fetchRound: "",
        fetchStandard: "",
        fetchStream: "",
        fieldNames: ["Application ID","Candidate Name","Mobile No","Email","Gender","Category","Merit No","Merit Marks","Academic year","Round","Standard","Stream"],
        importLoader: false,
        failed_allotment_list: [],
        result_dialog: false,
        active_tab: 0,
        success_allotment_list: [],
        success_headers: [
            { text: "Application ID", value: "application_id", align: "center" },
            { text: "Candidate Name", value: "candidate_name", align: "left" },
            { text: "Round", value: "round", align: "center" },
            { text: "Status", value: "status", align: "center" }
        ],
        failed_headers: [
            {
                text: "Application ID",
                value: "application_id",
                align: "center"
            },
            {
                text: "Candidate Name",
                value: "candidate_name",
                align: "left"
            },
            {
                text: "Round",
                value: "round",
                align: "center"
            },
            {
                text: "Reason",
                value: "reason",
                align: "center"
            }
        ],
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Add Allotment List" : "Edit Allotment List";
        },
        filteredRuleList() {
            if (!this.search) return this.allotment_list;

            const txt = this.search.toLowerCase();

            return this.allotment_list.filter(item => (item.name || "").toLowerCase().includes(txt)
            );
        },
        
        filter_standard_list() {
            return [{ id: 'ALL', standard: 'All' }, ...this.standard_list];
        },

        filter_admission_round_list() {
            return [{ id: 'ALL', name: 'All' }, ...this.admission_round_list];
        },

        filter_stream_list(){
            return [{id: 'ALL', name: 'All' }, ...this.stream_list];
        }
       
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        downloadFile() {
            this.loader = true;

            const excelData = this.filteredRuleList.map((item, index) => ({
                "S.No": index + 1,
                "Application Id": item.application_id,
                "Candiate Name": item.name,
                "Mobile No": item.mobile_no,
                "Email": item.email,
                "Gender": item.gender,
                "Category": item.category,
                "Merit No": item.merit_no,
                "Merit Marks": item.merit_marks,
                "Academic Year": item.ay,
                "Round": item.round,
                "Standard": item.standard,
                "Stream": item.stream,
                "Is Email Verified": item.is_email_verified ? "Yes" : "No",
                "Is Mobile Verified": item.is_mobile_verified ? "Yes" : "No"
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Allotment List");
            XLSX.writeFile(workbook, "AllotmentList.xlsx");

            this.loader = false;
        },

        editItem(item) {

            this.editedIndex = this.allotment_list.indexOf(item);

            this.editedItem = { ...item };

            this.name = item.name;
            this.mobile_no = item.mobile_no;
            this.email = item.email;
            this.application_id = item.application_id;
            this.merit_no = item.merit_no;
            this.merit_marks = item.merit_marks;

            this.standard = item.standard_id;
            this.round = item.round_id;
            this.stream = item.stream_id;
            this.gender = item.gender_id;
            this.category = item.category_id;
            this.ay = item.ay_id;

            this.is_email_verified = item.is_email_verified;
            this.is_mobile_verified = item.is_mobile_verified;
            this.getAdmissionRounds(this.standard);
            this.dialog = true;
        },

        onLoad() {
            this.overlay = true;
            this.name = "",
                this.mobile_no = "",
                this.email = "",
                this.application_id = "",
                this.merit_no = "",
                this.merit_marks = "",
                this.round = "",
                this.stream = "",
                this.standard = "",
                this.gender = "",
                this.category = "",
                this.ay = "",
                this.is_email_verified = "",
                this.is_mobile_verified = ""
            axios
                .post("/admission/getAllotmentLists")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        // this.allotment_list = res.data.allotment_lists.map((item, index) => ({
                        //     ...item,
                        //     srno: index + 1
                        // }));
                        this.standard_list = res.data.standard_list;
                        this.gender_list = res.data.gender_list;
                        this.category_list = res.data.category_list;
                        this.ay_list = res.data.ay_list;
                        this.stream_list = res.data.stream_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getAdmissionRounds(std) {
            this.overlay = true;
            const data = {
                standard: std
            }
            axios
                .post("/admission/fetchAdmissionList", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.admission_round_list = res.data.admission_rounds_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getAllotmentList() {
            if (!this.fetchAy) {
                this.showSnackbar("#b71c1c", "Please Select Academic Year");
                return;
            }
            if (!this.fetchStandard) {
                this.showSnackbar("#b71c1c", "Please Select Standard");
                return;
            }
            if (!this.fetchRound) {
                this.showSnackbar("#b71c1c", "Please Select Round");
                return;
            }
            if (!this.fetchStream) {
                this.showSnackbar("#b71c1c", "Please Select Stream");
                return;
            }

            this.overlay = true;
            const data = {
                ay: this.fetchAy,
                standard: this.fetchStandard,
                round: this.fetchRound,
                stream: this.fetchStream
            }

            axios
                .post("/admission/fetchAllotmentList", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.allotment_list = res.data.allotment_lists.map((item, index) => ({
                            ...item,
                            srno: index + 1
                        }));
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.dataLoader = false;
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.name = "",
                this.mobile_no = "",
                this.email = "",
                this.application_id = "",
                this.merit_no = "",
                this.merit_marks = "",
                this.round = "",
                this.stream = "",
                this.standard = "",
                this.gender = "",
                this.category = "",
                this.ay = "",
                this.is_email_verified = "",
                this.is_mobile_verified = ""
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (!this.isValidated()) {
                return;
            }

            const payload = {
                id: this.editedItem.id,
                name: this.name,
                mobile_no: this.mobile_no,
                email: this.email,
                application_id: this.application_id,
                merit_no: this.merit_no,
                merit_marks: this.merit_marks,
                round: this.round,
                stream: this.stream,
                standard: this.standard,
                gender: this.gender,
                category: this.category,
                ay: this.ay,
                is_email_verified: this.is_email_verified,
                is_mobile_verified: this.is_mobile_verified
            };

            if (this.editedIndex > -1) {
                this.overlay = true;
                axios
                    .post("/admission/editAllotmentList", payload)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Allotment List Updated Successfully...");
                            this.close();
                            if (this.fetchAy && this.fetchStandard && this.fetchRound && this.fetchStream) {
                                this.getAllotmentList();
                            }
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Allotment List Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });

            }
            else {
                this.overlay = true;
                axios
                    .post("/admission/saveAllotmentList", payload)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Allotment List Added Successfully...");
                            this.close();
                           if (this.fetchAy && this.fetchStandard && this.fetchRound && this.fetchStream) {
                               this.getAllotmentList();
                            }
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", res.data.msg || "Allotment List Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            }
        },

        isValidated() {

            if (!this.name) {
                this.showSnackbar("#b71c1c", "Enter Candidate Name");
                return false;
            }

            if (!this.mobile_no) {
                this.showSnackbar("#b71c1c", "Enter Mobile Number");
                return false;
            }

            if (!this.email) {
                this.showSnackbar("#b71c1c", "Enter Email");
                return false;
            }

            if (!this.application_id) {
                this.showSnackbar("#b71c1c", "Enter Application Form Number");
                return false;
            }

            if (!this.merit_no) {
                this.showSnackbar("#b71c1c", "Enter Merit Number");
                return false;
            }

            if (!this.merit_marks) {
                this.showSnackbar("#b71c1c", "Enter Merit Marks");
                return false;
            }

            if (!this.round) {
                this.showSnackbar("#b71c1c", "Select Admission Round");
                return false;
            }

            if (!this.stream) {
                this.showSnackbar("#b71c1c", "Select Stream");
                return false;
            }

            if (!this.standard) {
                this.showSnackbar("#b71c1c", "Select Standard");
                return false;
            }

            if (!this.gender) {
                this.showSnackbar("#b71c1c", "Select Gender");
                return false;
            }

            if (!this.category) {
                this.showSnackbar("#b71c1c", "Select Category");
                return false;
            }

            if (!this.ay) {
                this.showSnackbar("#b71c1c", "Select Academic Year");
                return false;
            }

            if (this.mobile_no.length != 10) {
                this.showSnackbar("#b71c1c", "Mobile Number must be 10 digits");
                return false;
            }

            return true;
        },

        deleteItem(item) {
            if (confirm("Are you sure you want to delete this List?")) {
                const data = {
                    id: item.id
                };
                axios
                    .post("/admission/deleteAllotmentList", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Allotment List Deleted Successfully...");
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            }
            this.close();
        },

         openFileSelector() {
            this.import_dialog = true;
        },

        generateExcel() {
        try {
          const dataForSheet = [this.fieldNames];
          const worksheet = XLSX.utils.aoa_to_sheet(dataForSheet);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Bulk Import Allotment List");
          const wscols = this.fieldNames.map(() => ({ wch: 20 }));
          worksheet['!cols'] = wscols;
          XLSX.writeFile(workbook, "Allotment_List_Template.xlsx");
          
        } catch (error) {
          console.error("Error generating Excel:", error);
          alert("Failed to generate Excel file.");
        }
      },

        importAllotmentList() {

            if (!this.file) {
            this.showSnackbar("#b71c1c", "Please select a file!");
            return;
            }

            const formData = new FormData();
            formData.append("file", this.file);
            this.importLoader = true;
            this.overlay = true;

            axios.post("/admission/importAllotmentList", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "EPS-token": localStorage.getItem("EPS-token"),
                "EPS-uid": localStorage.getItem("EPS-uid"),
                "router-path": this.$route.path
            }
            })
            .then((res) => {

                this.success_allotment_list = res.data.success_records || [];
                this.failed_allotment_list = res.data.skipped_records || [];

                if (this.success_allotment_list.length > 0 || this.failed_allotment_list.length > 0) {
                    this.active_tab = this.failed_allotment_list.length > 0 ? 1 : 0;
                    this.result_dialog = true;
                }

                if (res.data.code === "SUCCESS") {

                    this.showSnackbar("#4caf50", res.data.msg);
                    this.onLoad();

                } else if (res.data.code === "NA") {

                    this.showSnackbar("#b71c1c", res.data.msg || "No records imported");
                    this.onLoad();

                } else {

                    this.showSnackbar("#b71c1c", "Data Not Imported");
                    this.onLoad();
                }

                this.import_dialog = false;
                this.file = null;

            })
            .catch((error) => {
                console.error("Import failed:", error);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            })
            .finally(() => {
                this.overlay = false;
                this.importLoader = false;
            });
        },

       toggleSelectAll() {

            if (this.selectAll) {
                this.selectedRows = [...this.allotment_list];
            } else {
                this.selectedRows = [];
            }

        },

        sendNotification(type) {
            console.log("METHOD CALLED :", type);

            if (this.selectedRows.length == 0) {
                this.showSnackbar("#b71c1c", "Please select atleast one row");
                return;
            }

            const selectedIds = this.selectedRows.map(item => item.id);
            let successMessage = "";

            if (type == "EMAIL") {
                successMessage = "Emails sent successfully";
            } 
            else if (type == "WHATSAPP") {
                successMessage = "WhatsApp messages sent successfully";
            } 
            else if (type == "SMS") {
                successMessage = "SMS sent successfully";
            }

            const data={
                ids: selectedIds,
                type: type,
                dns: window.location.hostname
            }

            axios.post("/communicationType/sendAllotmentNotification",data)
            .then((res) => {
                if (res.data.status == "YES") {
                    this.showSnackbar("#4caf50", successMessage);
                    this.getAllotmentList();
                }else if(res.data.status == "NO") {
                    this.showSnackbar("#b71c1c","Failed to send notification");
                }else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                console.log(error);
                this.showSnackbar("#b71c1c", "Something went wrong");
            });

        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ td {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}
</style>